module.exports = __webpack_public_path__ + "img/bobuzo_bobocoin.gm.a1c2b54.png";